<template>
  <VMenu v-model="dValue" offset-y >
    <template #activator="{ props }">
      <span v-bind="props"></span>
    </template>
    <VCard width="300px" class="ChangeTechTypeDialog">
      <VCardText>
        {{ $t('C40101.ChangeTeachTypeDialog.bZLZT_-WPZ3kjE106hMci') }}
        <div>
          <VList>
            <VListItem v-for="item in items" :key="item.value" density="compact" class="selection" @click="selected(item)">
              {{item.title}}
            </VListItem>
          </VList>
        </div>
        {{ $t('C40101.ChangeTeachTypeDialog.Zufqf4750O4K_D00k1Nwp', [moment($store.state.C40101.C40101_canEdit_MaxDate).add(1, 'day').format('YYYY/MM/DD')]) }}
      </VCardText>
    </VCard>
  </VMenu>
</template>

<script>

export default {
  props:{
    teacher: {
      type: Object,
      required: true,
    },
    modelValue:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      dValue: this.modelValue,
      items: [
        { title: this.$t('C40101.ChangeTeachTypeDialog.FACcrQe0m6Ld52K1DHdBS'), value: 1 },
        { title: this.$t('C40101.ChangeTeachTypeDialog.LRFUziLt5-ahsmTHm01_0'), value: 2 },
      ],
    }
  },
  watch:{
    modelValue(newValue){
      this.dValue = newValue;
    },
    dValue(newValue){
      this.$emit('update:modelValue', newValue);
    }
  },
  methods:{
    moment: require('moment'),
    async selected(item){
      this.$emit('selected', item);
      console.log(item);
      if (this.teacher.teacher_type === item.value){
        this.dValue = false;
        this.$dialog.notify.info(this.$t('C40101.ChangeTeachTypeDialog.DWn-0HY3DQ3td9kirdk8y'));
        return;
      }

      const proceed = await this.$confirm({
        title: this.$t('common.confirm'),
        text: this.$t('C40101.ChangeTeachTypeDialog.t9-YW9PcaZbdhGF-rG6Lb', [this.teacher.teacher_name]),
        persistent: true,
        actions: [
          { key: true, text: this.$t('common.yes'), color: 'primary' },
          { key: false, text: this.$t('common.no') },
        ],
      });
      if (!proceed) return;

      this.$store.dispatch("C40101/C40101_setTeacherType", {
        teacher_no: this.teacher.teacher_no,
        teacher_type: item.value,
        lock_version: this.teacher.lock_version,
      });

      this.$dialog.notify.info(this.$t('C40101.ChangeTeachTypeDialog.W4AXEc5pj0h0tmkPL5vPe'));

      this.$emit('updatedTeacher', {
        ...this.teacher,
        teacher_type: item.value,
        lock_version: this.teacher.lock_version + 1,
      }
      );
      this.dValue = false;
    },
  }
}
</script>

<style>
.ChangeTechTypeDialog .selection:hover{
    background-color: #f0f0f0;
  }
</style>
